import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { getController } from '@shared/util/timeout';
import { GoogleMapsContext } from './GoogleMapsContext';
import { type GoogleMaps } from './types';

interface GoogleMapsProviderProps {
  children: ReactNode;
}

export function GoogleMapsProvider({ children }: GoogleMapsProviderProps) {
  const [googleMaps, setGoogleMaps] = useState<GoogleMaps>();

  useEffect(() => {
    const { signal, abort } = getController();

    setOptions({
      key: import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '',
      v: 'weekly',
    });

    importLibrary('places')
      .then(() => {
        if (signal.aborted) {
          return;
        }
        setGoogleMaps(google.maps);
      })
      .catch(() => {
        // Failed to load Maps JS API; context stays undefined
      });

    return abort;
  }, []);

  return <GoogleMapsContext.Provider value={googleMaps}>{children}</GoogleMapsContext.Provider>;
}
